export const click = ()=>({type: 'click'})
export const addSurveyMapping = (survey_mapping)=>({type: 'add_survey_mapping', survey_mapping})
export const removeSurveyMapping = (index)=>({ type: 'remove_survey_mapping', index })
export const changeSurveyMappingField = (index, field, value)=>({type: 'change_survey_mapping_value', index, field, value})